import React from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';


import Home from '../pages/Home';
import AboutUs from '../pages/AboutUs';
import Services from '../pages/Services';
import Pricing from '../pages/Pricing';
import Team from '../pages/Team';
import Faq from '../pages/Faq';
import BlogList from '../pages/BlogList';
import BlogDetail from '../pages/BlogDetail';
import ContactUs from '../pages/ContactUs';
import Login from '../pages/Login';
import Register from '../pages/Register';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import Backoffice from '../pages/Backoffice';
import AuthCallback from '../pages/AuthCallback';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsOfService from '../pages/TermsOfService';
import Legal from '../pages/Legal';
import CMSLayout from '../pages/cms/CMSLayout';
import Dashboard from '../pages/cms/dashboard';
import Users from '../pages/cms/users';
import Houses from '../pages/cms/houses';
import Photos from '../pages/cms/photos';
import Reservations from '../pages/cms/reservations';
import ICal from '../pages/cms/ical';
import ReservationHistory from '../pages/cms/reservations-history';
import StandardMessages from '../pages/cms/standard-messages';
import MessageComposer from '../pages/cms/standard-messages/composer';
import Translations from '../pages/cms/translations';
import Feedbacks from '../pages/cms/feedbacks';
import Blog from '../pages/cms/blog';
import ESign from '../pages/cms/e-sign';
import Contacts from '../pages/cms/contacts';
import ContactRequests from '../pages/cms/contact-requests';

import Footer from '../layout/Footer';
import Header from '../layout/Header';
import ScrollToTop from '../layout/ScrollToTop';
import Particls from '../layout/Particls';
import ProtectedRoute from '../components/ProtectedRoute';

const Router = () => {
    return (
        <>
            <Routes>
                {/* Routes with navbar and footer */}
                <Route element={<MainLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="about-us" element={<AboutUs />} />
                    <Route path="services" element={<Services />} />
                    <Route path="pricing" element={<Pricing />} />
                    <Route path="team" element={<Team />} />
                    <Route path="faq" element={<Faq />} />
                    <Route path="blog-list" element={<BlogList />} />
                    <Route path="blog-detail" element={<BlogDetail />} />
                    <Route path="contact" element={<ContactUs />} />
                    <Route path="privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="terms-of-service" element={<TermsOfService />} />
                    <Route path="legal" element={<Legal />} />
                </Route>

                {/* Routes without navbar and footer */}
                <Route path="login" element={<Login />} />
                <Route path="register" element={<Register />} />
                <Route path="forgot-password" element={<ForgotPassword />} />
                <Route path="reset-password" element={<ResetPassword />} />
                <Route path="backoffice" element={<Backoffice />} />
                <Route path="auth/google/callback" element={<AuthCallback />} />
                <Route path="auth/microsoft/callback" element={<AuthCallback />} />

                {/* CMS Routes with sidebar */}
                <Route path="cms" element={<CMSLayout />}>
                    <Route index element={<Dashboard />} />
                    <Route path="users" element={
                        <ProtectedRoute requiredPermission="users">
                            <Users />
                        </ProtectedRoute>
                    } />
                    <Route path="houses" element={
                        <ProtectedRoute requiredPermission="houses">
                            <Houses />
                        </ProtectedRoute>
                    } />
                    <Route path="photos" element={
                        <ProtectedRoute requiredPermission="photos">
                            <Photos />
                        </ProtectedRoute>
                    } />
                    <Route path="reservations" element={
                        <ProtectedRoute requiredPermission="reservations">
                            <Reservations />
                        </ProtectedRoute>
                    } />
                    <Route path="ical" element={
                        <ProtectedRoute requiredPermission="ical">
                            <ICal />
                        </ProtectedRoute>
                    } />
                    <Route path="reservation-history" element={
                        <ProtectedRoute requiredPermission="reservationHistory">
                            <ReservationHistory />
                        </ProtectedRoute>
                    } />
                    <Route path="standard-messages" element={
                        <ProtectedRoute requiredPermission="standardMessages">
                            <StandardMessages />
                        </ProtectedRoute>
                    } />
                    <Route path="standard-messages/composer" element={
                        <ProtectedRoute requiredPermission="standardMessages">
                            <MessageComposer />
                        </ProtectedRoute>
                    } />
                    <Route path="translations" element={
                        <ProtectedRoute requiredPermission="translations">
                            <Translations />
                        </ProtectedRoute>
                    } />
                    <Route path="feedbacks" element={
                        <ProtectedRoute requiredPermission="feedbacks">
                            <Feedbacks />
                        </ProtectedRoute>
                    } />
                    <Route path="blog" element={
                        <ProtectedRoute requiredPermission="blog">
                            <Blog />
                        </ProtectedRoute>
                    } />
                    <Route path="e-sign" element={
                        <ProtectedRoute requiredPermission="eSign">
                            <ESign />
                        </ProtectedRoute>
                    } />
                    <Route path="contact-requests" element={
                        <ProtectedRoute requiredPermission="dashboard">
                            <ContactRequests />
                        </ProtectedRoute>
                    } />
                    <Route path="contacts" element={<Contacts />} />
                </Route>
            </Routes>
            <ScrollToTop />
        </>
    );
};

function MainLayout(){
    return (
        <div className='main'>
            <Header />
            <Outlet />
            <Footer />
            <Particls />
        </div>
    )
}

export default Router;